import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { ADTSettings  } from 'angular-datatables/src/models/settings';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { BasicActionsEventType } from '../DatatableEvents/basic-actions-event-type';
import { BasicActionsComponent } from '../DatatableEvents/basic-actions.component';
class DataTablesResponse {
  data: any[];
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
declare var bootstrap: any;

@Component({
  selector: 'app-admin-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss']
})
export class RulesComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  @ViewChild('basicActions') basicActions: TemplateRef<BasicActionsComponent>;
  message = '';
  editRule=null;
  modalid="newrule"
  modalid1="deletecommon"
  deleteid=""
  
  dtTrigger: Subject<ADTSettings> = new Subject<ADTSettings>();
  //dtOptions: DataTables.Settings = {};
  dtOptions: ADTSettings = {};
  
  constructor(public adminApi: AdminapiService){

  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      $('table.dataTable').DataTable().clearPipeline().draw();
      //dtInstance.clearPipeline().draw()
      //dtInstance.clear().draw();
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(this.dtOptions);
    });
  }

  changeData(event){
    this.rerender()
  }

  ngOnInit(): void {
    setTimeout(() => {
      const self = this;
      this.dtOptions = {
        language: {
          searchPlaceholder: "Search name...",
          // search: "Search:",
        },
        serverSide: true,  
        ordering:false,
        processing: true,
        lengthMenu:['10','20','30','40','50'],
        //order: [[0, 'desc']],
        //columnDefs: [{ targets: 3, orderable: false }],
        pageLength: 50,   // Set the flag 
        ajax: this.adminApi.getRules(),
        columns: [{
          title: 'ID',
          data: 'id'
        }, {
          title: 'Name',
          data: 'name'
        }
        ,
        {
          title: 'Actions',
          data: null,
          ngTemplateRef: {
            ref: this.basicActions,
            context: {
              // needed for capturing events inside <ng-template>
              captureEvents: self.onCaptureEvent.bind(self),
            }
          }
        
        },
        // {
        //   title: 'Action',
        //   data:null, 
        //   defaultContent:'<button (click)="editRule($event,row)" class="btn btn-info editBtn">Edit</button>'
        //   // render:function(data, type, row, meta){
        //   //   return `<button (ngClick)="editRule($event,row)" class="btn btn-info editBtn">Edit</button>`;
        //   // }
        // }
      ],
        // createdRow: ((row: Node, data: any[] | object, dataIndex: number) => {

        //   // How to compile Angular 5 directive in this.
        // }),
        // drawCallback: () => {
        //   $('.editBtn').on('click', () => {  //click event on button with class `buttonClass`
              
        //     console.log("clicked");
        //   });
        // },
        // rowCallback: (row:Node, data:[] | object, index:number)=>{
        //   row.childNodes[0].textContent = String(index + 1);      
        //   const self = this;
        //   $('td' ,row).off('click');
        //   $('td',row).on('click',()=>{
        //     console.log(row)
        //     //this.updateClicked(data);
        //   });
        //   return row;
        //   }
      };
      
    });
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      // race condition fails unit tests if dtOptions isn't sent with dtTrigger
      this.dtTrigger.next(this.dtOptions);
    }, 200);
  }

  onCaptureEvent(event: BasicActionsEventType) {
    //this.message = `Event '${event.cmd}' with data '${JSON.stringify(event.data)}`;
    if(event.cmd=='edit'){
      this.editRule = event.data;
      this.openModal()
    }
    if(event.cmd=='delete'){
      this.deleteid = event.data.id;
      this.openConfirmModal()
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  addNewModal() {
    this.editRule = null;

    this.openModal()
  }

  openModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }

  openConfirmModal(){
    setTimeout(()=>{
      if(document.getElementById(this.modalid1)){
        var myModal = new bootstrap.Modal(document.getElementById(this.modalid1), {
          keyboard: true
        })
        myModal.show()
      }
    },300)
  }

}
